import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const EmojiFillHappyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmojiFillHappy",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m4.87 9.77c1.07 0 1.94.87 1.94 1.94s-.87 1.94-1.94 1.94-1.94-.87-1.94-1.94.87-1.94 1.94-1.94m-9.75 0c1.07 0 1.94.87 1.94 1.94s-.87 1.94-1.94 1.94-1.94-.87-1.94-1.94.87-1.94 1.94-1.94m11.83 9.56c-1.89 1.54-4.3 2.5-6.94 2.58h-.02c-2.65-.08-5.06-1.04-6.97-2.6l.02.02a.89.89 0 0 1-.31-.67.892.892 0 0 1 1.48-.67 9.76 9.76 0 0 0 5.76 2.14h.02c2.21-.08 4.21-.88 5.81-2.16h-.02c.16-.12.36-.2.59-.2.49 0 .89.4.89.89 0 .27-.12.51-.31.67"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0m4.57 10.29c1.26 0 2.29 1.02 2.29 2.29s-1.02 2.29-2.29 2.29-2.29-1.02-2.29-2.29 1.02-2.29 2.29-2.29m-9.14 0c1.26 0 2.29 1.02 2.29 2.29s-1.02 2.29-2.29 2.29-2.29-1.02-2.29-2.29 1.02-2.29 2.29-2.29m12.4 9.57c-1.3 3.21-4.38 5.28-7.83 5.28s-6.53-2.07-7.83-5.28c-.24-.58.04-1.25.63-1.49s1.25.05 1.49.63c.95 2.35 3.19 3.86 5.71 3.86s4.76-1.51 5.71-3.86c.23-.58.89-.87 1.49-.63.58.24.87.9.63 1.49"
      })
    })
  }));
};
EmojiFillHappyIcon.displayName = 'EmojiFillHappyIcon';